export default {"src":"/_next/static/media/safepoints_40.1cfca1c4.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};